<template>
  <PageContainer>
    <CalloutComponent
      type='info'
      :showIcon=true
    >
      Continue your coaching plan to unlock tools to improve your sleep.
      <!-- Track more sleep sessions to unlock tools to improve your sleep. -->
    </CalloutComponent>
    <h4>Bed time routine</h4>
    <div class="grid grid-cols-2 gap-4 my-4">
      <ToolComponent
        v-for="tool in bedtimeTools" :key="tool"
        @click="tool.unlockDate ? openToolModal(tool) : null"
        :name="tool.name"
        :icon="tool.icon"
        :unlocked="Boolean(tool.unlockDate)"
      />
    </div>
    <h4>Morning routine</h4>
    <div class="grid grid-cols-2 gap-4 my-4">
      <ToolComponent
        v-for="tool in morningTools" :key="tool"
        @click="tool.unlockDate ? openToolModal(tool) : null"
        :name="tool.name"
        :icon="tool.icon"
        :unlocked="Boolean(tool.unlockDate)"
      />
    </div>
    <h4>Daily habits</h4>
    <div class="grid grid-cols-2 gap-4 my-4">
      <ToolComponent
        v-for="tool in dailyTools" :key="tool"
        @click="tool.unlockDate ? openToolModal(tool) : null"
        :name="tool.name"
        :icon="tool.icon"
        :unlocked="Boolean(tool.unlockDate)"
      />
    </div>
    <h4>Sleeping environment</h4>
    <div class="grid grid-cols-2 gap-4 my-4">
      <ToolComponent
        v-for="tool in environmentTools" :key="tool"
        @click="tool.unlockDate ? openToolModal(tool) : null"
        :name="tool.name"
        :icon="tool.icon"
        :unlocked="Boolean(tool.unlockDate)"
      />
    </div>
  </PageContainer>
  <ToolModal
    v-model="toolModal"
    v-model:toolObject="toolSelected"
  />
</template>

<script>
import PageContainer from '@/components/PageContainer'
import CalloutComponent from '@/components/CalloutComponent'
import ToolComponent from '@/components/ToolComponent'
import ToolModal from '@/components/modals/ToolModal'
import { mapStores } from 'pinia'
import { useToolStore } from '@/stores/tool'

export default {
  name: 'ToolkitPage',
  components: {
    PageContainer,
    CalloutComponent,
    ToolComponent,
    ToolModal,
  },
  props: {
  },
  emits: [
  ],
  data() {
    return {
      toolModal: false,
      toolSelected: undefined,
    }
  },
  async beforeMount() {
    await this.loadTools()
    this.handleParams()
  },
  watch: {
  },
  methods: {
    async loadTools() {
      // Ensure we initialise the store with the toolkit.
      return await this.toolStore.load()
    },
    handleParams() {
      // if (this.$route.query.id) {
      //   this.tool = this.toolStore.getTool(this.$route.query.id)
      //   this.showNewTool = true
      //   this.toolModal = true
      //   this.$router.replace(this.$router.currentRoute.path)
      // }
    },
    openToolModal(tool) {
      this.toolModal = true
      this.toolSelected = tool
    },
    byUnlocked(a, b) {
      return (a.unlockDate && b.unlockDate) ? 0 : (a.unlockDate ? -1 : 1)
    },
  },
  computed: {
    // Sort each array so that loacked tools are at the end.
    // TODO: Change these computed functions to use try-catch blocks.
    bedtimeTools() {
      if (!Array.isArray(this.toolStore.toolsArray)) return
      return this.toolStore.toolsArray?.filter(tool => tool.category === 'BEDTIME_ROUTINE').sort(this.byUnlocked)
    },
    morningTools() {
      if (!Array.isArray(this.toolStore.toolsArray)) return
      return this.toolStore.toolsArray?.filter(tool => tool.category === 'MORNING_ROUTINE').sort(this.byUnlocked)
    },
    dailyTools() {
      if (!Array.isArray(this.toolStore.toolsArray)) return
      return this.toolStore.toolsArray?.filter(tool => tool.category === 'DAILY_HABITS').sort(this.byUnlocked)
    },
    environmentTools() {
      if (!Array.isArray(this.toolStore.toolsArray)) return
      return this.toolStore.toolsArray?.filter(tool => tool.category === 'SLEEPING_ENVIRONMENT').sort(this.byUnlocked)
    },
    ...mapStores(useToolStore),
  }
}
</script>